// @flow

import React, { Component } from 'react';

import Button from 'app/common/components/Button';
import Keydown from 'app/common/components/Keydown';
import Modal, { ModalActions } from 'app/common/components/Modal';
import { getRef, setRef } from 'app/common/utils/ReactUtils';

type RenameZapProps = {
  zapTitle: string,
  onSave: (title: string) => void,
  onCloseModal: () => void,
};

type RenameZapState = {
  title: string,
};

class RenameZapStateful extends Component<RenameZapProps, RenameZapState> {
  state = { title: this.props.zapTitle };

  componentDidMount = () => {
    const textField = getRef(this, 'textField');
    textField.focus();
    textField.select();
  };

  handleOnChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({ title: event.target.value });
  };

  doSave = () => {
    this.props.onSave(this.state.title);
  };

  render() {
    return (
      <Modal
        closeOnEsc={true}
        hideCloseButton={true}
        isOpened={true}
        onClose={this.props.onCloseModal}
      >
        <div>
          <h1>Rename your Zap</h1>
          <div>
            <Keydown
              handlers={{
                enter: {
                  handler: this.doSave,
                  stopPropagation: true,
                  preventDefault: true,
                },
              }}
            >
              <input
                defaultValue={this.state.title}
                onChange={this.handleOnChange}
                placeholder="Name"
                ref={setRef(this, 'textField')}
                type="text"
              />
            </Keydown>
          </div>
          <ModalActions>
            <Button kind="secondary large" onClick={this.props.onCloseModal}>
              Cancel
            </Button>
            <Button kind="primary large" onClick={this.doSave}>
              Save
            </Button>
          </ModalActions>
        </div>
      </Modal>
    );
  }
}

export default RenameZapStateful;
